import { Model } from '../parents/model';

export class OrderShippingMethodModel extends Model {
  static ATTR_ID = 'id';

  static ATTR_NAME = 'name';

  static ATTR_PRICE = 'price';

  static ATTR_TAXED_PRICE = 'taxed_price';

  static ATTR_SHIPPING_METHOD_ID = 'shipping_method_id';

  static ATTR_SHIPPING_OPTION_ID = 'shipping_option_id';

  static ATTR_SHIPPING_SERVICE = 'shipping_service';

  static ATTR_ORDER_ID = 'order_id';

  static ATTR_TRACKING_NUMBERS = 'tracking_numbers';

  static ATTR_CREATED_AT = 'created_at';

  static ATTR_UPDATED_AT = 'updated_at';

  static ATTR_NOTIFY_CHANGE = 'notify_change';

  static ATTR_NOTE = 'note';

  static EMBED_SHIPPING_METHOD = 'shipping_method';

  static EMBED_SHIPPING_OPTION = 'shipping_option';

  get id() {
    return this.attributes[OrderShippingMethodModel.ATTR_ID];
  }

  get name() {
    return this.attributes[OrderShippingMethodModel.ATTR_NAME];
  }

  get price() {
    return this.attributes[OrderShippingMethodModel.ATTR_PRICE];
  }

  get taxedPrice() {
    return this.attributes[OrderShippingMethodModel.ATTR_TAXED_PRICE];
  }

  get shippingMethodId() {
    return this.attributes[OrderShippingMethodModel.ATTR_SHIPPING_METHOD_ID];
  }

  get shippingOptionId() {
    return this.attributes[OrderShippingMethodModel.ATTR_SHIPPING_OPTION_ID];
  }

  get ShippingService() {
    return this.attributes[OrderShippingMethodModel.ATTR_SHIPPING_SERVICE];
  }

  get orderId() {
    return this.attributes[OrderShippingMethodModel.ATTR_ORDER_ID];
  }

  get trackingNumbers() {
    return this.attributes[OrderShippingMethodModel.ATTR_TRACKING_NUMBERS];
  }

  get createdAt() {
    return this.attributes[OrderShippingMethodModel.ATTR_CREATED_AT];
  }

  get updatedAt() {
    return this.attributes[OrderShippingMethodModel.ATTR_UPDATED_AT];
  }

  get shippingMethod() {
    return this.embeds[OrderShippingMethodModel.EMBED_SHIPPING_METHOD];
  }

  get shippingOption() {
    return this.embeds[OrderShippingMethodModel.EMBED_SHIPPING_OPTION];
  }
}
